/**
 * @generated SignedSource<<c87ec98f4c1054c2a3a9e081997ce860>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BookmarkTabModalEditMutation$variables = {
  isEmbedded?: boolean | null;
  link?: string | null;
  streamId: string;
  tabId: string;
  title?: string | null;
};
export type BookmarkTabModalEditMutation$data = {
  readonly StreamTab_EditBookmarkTab: {
    readonly stream: {
      readonly id: string;
      readonly tabs: ReadonlyArray<{
        readonly icon: string | null;
        readonly id: string;
        readonly isEmbedded: boolean;
        readonly order: number;
        readonly otherStreamId: string | null;
        readonly title: string;
        readonly url: string | null;
      }>;
    };
  } | null;
};
export type BookmarkTabModalEditMutation = {
  response: BookmarkTabModalEditMutation$data;
  variables: BookmarkTabModalEditMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isEmbedded"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "link"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "streamId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tabId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "isEmbedded",
        "variableName": "isEmbedded"
      },
      {
        "kind": "Variable",
        "name": "link",
        "variableName": "link"
      },
      {
        "kind": "Variable",
        "name": "streamId",
        "variableName": "streamId"
      },
      {
        "kind": "Variable",
        "name": "tabId",
        "variableName": "tabId"
      },
      {
        "kind": "Variable",
        "name": "title",
        "variableName": "title"
      }
    ],
    "concreteType": "EditBookmark",
    "kind": "LinkedField",
    "name": "StreamTab_EditBookmarkTab",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "stream",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStreamTabNode",
            "kind": "LinkedField",
            "name": "tabs",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "otherStreamId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "order",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isEmbedded",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BookmarkTabModalEditMutation",
    "selections": (v6/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "BookmarkTabModalEditMutation",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "7f6a3a03c1f36323952327997500295d",
    "id": null,
    "metadata": {},
    "name": "BookmarkTabModalEditMutation",
    "operationKind": "mutation",
    "text": "mutation BookmarkTabModalEditMutation(\n  $streamId: ID!\n  $tabId: String!\n  $title: String\n  $link: String\n  $isEmbedded: Boolean\n) {\n  StreamTab_EditBookmarkTab(streamId: $streamId, tabId: $tabId, title: $title, link: $link, isEmbedded: $isEmbedded) {\n    stream {\n      id\n      tabs {\n        id\n        otherStreamId\n        icon\n        title\n        order\n        isEmbedded\n        url\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7b3425179027840e95c5852ccbb66c62";

export default node;
